import { isBindingContextLoaded } from "../../../common/module-guard";

import { DefaultCanvasArc3DRender } from "./arc3d-render";

import { Arc3dRender, GraphicRender } from "./symbol";

const loadedArc3dModuleContexts = new WeakSet;

export function bindArc3dRenderModule({bind: bind}) {
    isBindingContextLoaded(loadedArc3dModuleContexts, bind) || (bind(DefaultCanvasArc3DRender).toDynamicValue((() => new DefaultCanvasArc3DRender)).inSingletonScope(), 
    bind(Arc3dRender).toService(DefaultCanvasArc3DRender), bind(GraphicRender).toService(Arc3dRender));
}

export const arc3dModule = bindArc3dRenderModule;
//# sourceMappingURL=arc3d-module.js.map
